import "./App.css";
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";

import PrivacyPolicy from "./pages/privacy-policy";
import Tasks from "./pages/tasks";
import Welcome from "./pages/welcome";
import About from "./pages/about";
import WipTooltipListener from "./components/WipTooltipListener";

const FIRST_RUN_KEY = "foxer_seen_welcome_v1";

const AppShell = ({ children }) => {
  const { pathname } = useLocation();
  const isWelcome = pathname === "/welcome";
  return <div className="App" style={{ padding: isWelcome ? "0" : "0 16px" }}>{children}</div>;
};

const HideOnWelcome = ({ children }) => {
  const { pathname } = useLocation();
  return pathname === "/welcome" ? null : children;
};

const WelcomeGate = ({ seen, children }) => {
  const { pathname } = useLocation();

  // only force NEW users to /welcome
  if (!seen && pathname !== "/welcome") return <Navigate to="/welcome" replace />;

  // ✅ allow /welcome even if seen
  return children;
};

function App() {
  const [seen, setSeen] = useState(() => localStorage.getItem(FIRST_RUN_KEY) === "1");

  const formatDate = () => {
    const d = new Date();
    return `${d.toLocaleString("en-US", { month: "short" })} ${d.getDate()} · ${d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })}`;
  };

  const InfoTime = () => {
    const [time, setTime] = useState(formatDate());
    useEffect(() => {
      const id = setInterval(() => setTime(formatDate()), 60_000);
      return () => clearInterval(id);
    }, []);
    return time;
  };

  return (
    <ThemeProvider>
      <Router>
        <WelcomeGate seen={seen}>
          <AppShell>
            <Routes>
              <Route path="/" element={<Tasks />} />
              <Route path="/welcome" element={<Welcome onDone={() => setSeen(true)} />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/about" element={<About />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>

            <HideOnWelcome>
              <p
                className="current-time"
              >
                <InfoTime />
              </p>
            </HideOnWelcome>

            <div id="wip-tooltip">WIP</div>
            <WipTooltipListener />
          </AppShell>
        </WelcomeGate>
      </Router>
    </ThemeProvider>
  );
}

export default App;
